// Cache utility for analysis results
const CACHE_PREFIX = {
  HASHTAG: 'hashtag_',
  PROFILE: 'profile_',
  COMMENT: 'lastCommentAnalysis',
  TIME: 'lastTimeAnalysis',
  LIKE_RATE: 'lastLikeRateAnalysis',
  CONVERSION: 'lastConversionAnalysis',
  POST_TIMING: 'lastPostTimingAnalysis'
};

export const cacheAnalysisResult = (type, key, data) => {
  const cacheKey = type.startsWith('hashtag_') || type.startsWith('profile_') 
    ? `${type}${key}`
    : type;

  const cacheData = {
    data,
    timestamp: new Date().toISOString()
  };

  localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  console.log(`Cached ${type} analysis for ${key}:`, cacheData);
  
  // Dispatch custom event for cache updates
  window.dispatchEvent(new CustomEvent('cacheUpdated', {
    detail: { key: cacheKey, type }
  }));
};

export const getCachedResult = (type, key = '') => {
  const cacheKey = type.startsWith('hashtag_') || type.startsWith('profile_')
    ? `${type}${key}`
    : type;

  try {
    const cached = localStorage.getItem(cacheKey);
    if (!cached) return null;

    return JSON.parse(cached);
  } catch (error) {
    console.error('Error reading cached result:', error);
    return null;
  }
};

export const CACHE_TYPES = {
  HASHTAG: 'hashtag_',
  PROFILE: 'profile_',
  COMMENT: CACHE_PREFIX.COMMENT,
  TIME: CACHE_PREFIX.TIME,
  LIKE_RATE: CACHE_PREFIX.LIKE_RATE,
  CONVERSION: CACHE_PREFIX.CONVERSION,
  POST_TIMING: CACHE_PREFIX.POST_TIMING
};

const cacheService = {
  cacheAnalysisResult,
  getCachedResult,
  CACHE_TYPES
};

export default cacheService;
